import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import PhoneInput, { PhoneInputProps } from 'react-phone-input-2';
import ruLang from 'react-phone-input-2/lang/ru.json';

import styles from './styles.module.scss';

export interface PhoneNumberInputProps extends Omit<PhoneInputProps, 'onChange'> {
  name?: string;
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const PhoneNumberInput: FC<PhoneNumberInputProps> = ({ onChange, value, disabled, ...inputProps }) => {
  const { i18n, t } = useTranslation();

  return (
    <PhoneInput
      inputProps={inputProps}
      placeholder={inputProps.placeholder ?? '+7 (999) 999-99-99'}
      country="ru"
      value={value}
      localization={i18n.language === 'ru' ? ruLang : undefined}
      enableSearch
      onChange={(value, data, event) => {
        onChange?.(event);
      }}
      disabled={disabled}
      disableDropdown={disabled}
      searchPlaceholder={t('search') ?? undefined}
      containerClass={styles.container}
      inputClass={styles.input}
      dropdownClass={styles.dropdown}
      buttonClass={styles.buttonClass}
    />
  );
};

export default PhoneNumberInput;
